/** @file True when a bone is one of the given roots or a descendant of one (walks the parent array). */

/** Walks `parents` from `bone` up to the root; true when any visited index is in `roots`. */
export function inBoneSubtree(parents: readonly number[], bone: number, roots: readonly number[]): boolean {
  for (let b = bone; b >= 0; b = parents[b] ?? -1) if (roots.includes(b)) return true;
  return false;
}
